import { useOutputVectorStore } from '../dal/output-vector-store';
import { calculateOutputVector } from '../domain/output-vector-provider';

const OutputVectorView = () => {

    const params = useOutputVectorStore(store => store.params);
    const { calculations } = calculateOutputVector(params);

    return (
        <div className="flex gap-4 items-start">
            <div>
                {
                    calculations.map((calculation, i) => {
                        return (
                            <div key={ `calc-${ i }` }>
                                { calculation }
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
};

export default OutputVectorView;